const getGRecaptchaToken = async (executeRecaptcha, id) => {
  if (!executeRecaptcha) {
    return;
  }

  const gReCaptchaToken = await executeRecaptcha(id);

  return gReCaptchaToken;
};

export default getGRecaptchaToken;

export const getAuthGRecaptchaToken = () => {
  return null;
};
